export type Section = 'bookings' | 'customers' | 'resources' | 'rules' | 'feedback' | 'reports' | 'staff'
  | 'settings-general' | 'settings-availability' | 'settings-booking' | 'settings-payments'
  | 'settings-website' | 'settings-links' | 'settings-domains' | 'settings-delivery' | 'settings-feedback'

export const sectionPath: Record<Section, string> = {
  bookings: '/dashboard/bookings',
  customers: '/dashboard/customers',
  resources: '/dashboard/resources',
  rules: '/dashboard/rules',
  feedback: '/dashboard/feedback',
  reports: '/dashboard/reports',
  staff: '/dashboard/team',
  'settings-general': '/dashboard/settings/general',
  'settings-availability': '/dashboard/settings/availability',
  'settings-booking': '/dashboard/settings/booking',
  'settings-payments': '/dashboard/settings/payments',
  'settings-website': '/dashboard/settings/website',
  'settings-links': '/dashboard/settings/links',
  'settings-domains': '/dashboard/settings/domains',
  'settings-delivery': '/dashboard/settings/delivery',
  'settings-feedback': '/dashboard/settings/feedback',
}

export function requestedDashboardSection(): Section {
  const path = window.location.pathname.replace(/\/$/, '')
  const direct = (Object.entries(sectionPath) as Array<[Section, string]>).find(([, value]) => value === path)?.[0]
  if (direct) return direct
  if (path === '/dashboard/settings') return 'settings-general'
  const legacy = new URLSearchParams(window.location.search).get('section')
  if (legacy === 'settings') return 'settings-general'
  if (legacy === 'staff') return 'staff'
  if (legacy && legacy in sectionPath) return legacy as Section
  return 'bookings'
}
